import {
  ContentOwner,
  EDIT_CLIENT_USER_PROFILE,
  EditClientUserProfileAPI,
  Exceptions,
  GET_CLIENT_USER,
  GET_CLIENT_USER_AUTH_TOKEN,
  GET_CLIENT_USER_PROFILE,
  GetClientUserAPI,
  GetClientUserAuthTokenAPI,
  GetClientUserProfileAPI,
  IS_CLIENT_USER_CONTENT_OWNER,
  IsClientUserContentOwnerAPI,
  GET_CONTENT_TOKEN,
  GetContentTokenAPI,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '../helper/subscription-handler'
import { getClientUser, getClientUserId } from '$logic/client-user'
import { getProfile } from '$logic/profile'
import { decodeSubscriptionPermissions } from '$logic/subscription'
import { getClientUserIdentityToken } from '$logic/auth'
import { getImageUrl } from '$func/imageUrl'

wappSubscription.subscribe<GetClientUserAuthTokenAPI>(
  GET_CLIENT_USER_AUTH_TOKEN,
  async () => {
    const authToken = await getClientUserIdentityToken()
    return authToken
      ? { authToken }
      : { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)

wappSubscription.subscribe<GetClientUserAPI>(GET_CLIENT_USER, async () => {
  const { updatedAt, image, verified, ...user } = await getClientUser()
  return { ...user, image: getImageUrl(image), ...(verified && { verified }) }
})

wappSubscription.subscribe<GetClientUserProfileAPI>(
  GET_CLIENT_USER_PROFILE,
  () => {
    return (
      (getProfile() as any) ?? {
        errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE,
      }
    )
  },
)

wappSubscription.subscribe<EditClientUserProfileAPI>(
  EDIT_CLIENT_USER_PROFILE,
  () => {
    //   TODO: Implement later
    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)

wappSubscription.subscribe<IsClientUserContentOwnerAPI>(
  IS_CLIENT_USER_CONTENT_OWNER,
  async ({ contentOwner }) => {
    async function isClientUserContentOwner({ id, type }: ContentOwner) {
      if (type === 'WAPP') return false
      if (type === 'USER' && id === getClientUserId()) return true
      const permissions = await decodeSubscriptionPermissions(id)
      return permissions.sendWapp
    }
    const isContentOwner = await isClientUserContentOwner(contentOwner)
    return { isContentOwner }
  },
)

wappSubscription.subscribe<GetContentTokenAPI>(
  GET_CONTENT_TOKEN,
  async ({ contentUri }) => {
    const token = await getClientUserIdentityToken(contentUri)
    return token
      ? { token }
      : { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)
